<div class="text-right">
    <button *ngIf="!pageFixApplied" type="button" class="btn btn-border-radius btn-secondary" (click)="goToView()">
        {{ 'Fix options' | translate }}
    </button>

    <button *ngIf="pageFixApplied" type="button" class="btn btn-border-radius btn-secondary" (click)="goToView()">
        {{ 'Manage options' | translate }}
    </button>
</div>
